import React, { useRef, useState } from 'react';
import { motion, useInView, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

const faqs = [
  { q: 'Does Bonk support Rekordbox 6 and 7 databases?', a: 'Yes. Bonk syncs directly with Rekordbox database workflows so playlists, cues, and metadata stay aligned.' },
  { q: 'What are Quick Tag and Watch Folder for?', a: 'Quick Tag is for fast folder-scoped edits, while Watch Folder continuously ingests and enriches newly added tracks.' },
  { q: 'Can I plan sets in Bonk?', a: 'Yes. PathFlo helps design transitions visually, and JourneyFlo helps structure energy arcs with reusable sections.' },
  { q: 'What insights come from Analytics and Benchmark Center?', a: 'Analytics gives library-level trends for set prep. Benchmark Center measures scan/sort/cache performance on your machine.' },
  { q: 'How can I get updates?', a: 'Join the waitlist below to hear about launch timing, release notes, and major feature rollouts.' },
];

export default function FAQ() {
  const ref = useRef(null);
  const v = useInView(ref, { once: true, margin: '-80px' });
  const [open, setOpen] = useState(-1);

  return (
    <section id="faq" data-testid="faq-section" ref={ref} className="section section--border-top">
      <div className="container">
        <div className="split-grid split-grid--faq faq-grid">
          <motion.div
            className="section-header section-header--left"
            initial={{ opacity: 0, y: 30 }}
            animate={v ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8 }}
          >
            <span className="eyebrow">FAQ</span>
            <h2 data-testid="faq-title" className="section-title">
              Questions<br /><span className="section-title-muted">&amp; answers</span>
            </h2>
          </motion.div>

          <div className="faq-list">
            {faqs.map((f, i) => (
              <div key={f.q} data-testid={`faq-item-${i}`} className="faq-item">
                <button
                  type="button"
                  data-testid={`faq-toggle-${i}`}
                  className="faq-toggle"
                  aria-expanded={open === i}
                  onClick={() => setOpen(open === i ? -1 : i)}
                >
                  <span className="faq-question">{f.q}</span>
                  <ChevronDown className="faq-chevron" size={16} aria-hidden="true" />
                </button>
                <AnimatePresence>
                  {open === i && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3, ease: [0.25, 1, 0.5, 1] }}
                      style={{ overflow: 'hidden' }}
                    >
                      <p data-testid={`faq-answer-${i}`} className="faq-answer">{f.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
